import { useEffect } from "react";

import { Button, Icon_CheckmarkFilled60 } from "@shapr3d/frontend-lib";
import classNames from "classnames";

import WarningIcon from "../../assets/images/warning-icon.svg";
import useNavigation from "../../hooks/navigation";
import useTranslation from "../../hooks/useTranslation";
import DownloadSection from "../DownloadSection/DownloadSection";
import Heading from "../Heading/Heading";
import { NewZendeskTicketLink } from "../NewZendeskTicketLink/NewZendeskTicketLink";

import style from "./VoucherClaimResult.module.css";

export enum VoucherClaimRequestResult {
  Success = "SUCCESS",
  MultipleSubscriptionsError = "MULTIPLE_ACTIVE_SUBSCRIPTIONS",
  InvalidVoucherError = "INVALID_VOUCHER",
  UnknownError = "UNKNOWN_ERROR",
}

interface VoucherClaimResultProps {
  result: VoucherClaimRequestResult;
  isVerificationError?: boolean;
}

const VoucherClaimResult = (props: VoucherClaimResultProps) => {
  const navigation = useNavigation();
  const { t, m } = useTranslation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const goToProfile = () => {
    navigation.goToProfile(["voucherId"]);
  };
  return (
    <div className={style.wrapperContainer}>
      <div className={style.wrapperCenter}>
        {props.result === VoucherClaimRequestResult.Success && (
          <>
            <Icon_CheckmarkFilled60
              className={classNames(style.icon, style.checkIcon)}
              role="img"
            />
            <Heading type="h1" className={style.header}>
              {t(m.VoucherClaim.SuccessTitle, {
                br: () => <br />,
              })}
            </Heading>

            <DownloadSection />
          </>
        )}

        {props.result === VoucherClaimRequestResult.InvalidVoucherError && (
          <>
            <img src={WarningIcon} className={style.icon} />
            <Heading type="h1">{t(m.VoucherClaim.InvalidOrExpired)}</Heading>
            {!props.isVerificationError && (
              <div style={{ padding: "50px" }}>
                <Button onClick={goToProfile}>{t(m.VoucherClaim.ViewYourSubscription)}</Button>
              </div>
            )}
          </>
        )}
        {props.result === VoucherClaimRequestResult.MultipleSubscriptionsError && (
          <>
            <img src={WarningIcon} className={style.icon} />
            <Heading type="h1">{t(m.VoucherClaim.OnlyValidForNoActiveSubscription)}</Heading>
            <div style={{ padding: "50px" }}>
              <Button onClick={goToProfile}>{t(m.VoucherClaim.ViewYourSubscription)}</Button>
            </div>
          </>
        )}
        {props.result === VoucherClaimRequestResult.UnknownError && (
          <>
            <img src={WarningIcon} className={style.icon} />
            <Heading type="h1">{t(m.VoucherClaim.ErrorActivating)}</Heading>
            <div style={{ padding: "20px" }}>
              {t(m.VoucherClaim.ErrorActivatingDescription, {
                link: (chunks) => <NewZendeskTicketLink>{chunks}</NewZendeskTicketLink>,
              })}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default VoucherClaimResult;
